 <!-- Authentication Modal -->

    <div class="modal fade" id="authModal" #authModal tabindex="-1" aria-labelledby="authModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="authModalLabel">Authentication</h5>
                    <button type="button" class="btn-close" (click)="closeModalById('authModal')"></button>
                </div>
                <div class="modal-body">
                    <form #authForm="ngForm" (ngSubmit)="submitAuth()">
                        <div class="mb-3">
                            <label for="passcode" class="form-label">Passcode</label>
                            <input type="password" #passCodeInput id="passcode" name="passcode" class="form-control" required
                                [(ngModel)]="passcode">
                        </div>
                        <div class="mb-3">
                            <label for="enteredBy" class="form-label">Entered By</label>
                            <select id="enteredBy" name="enteredBy" class="form-select" required
                                [(ngModel)]="enteredBy">
                                <option value=null disabled selected>Select User</option>
                                <option *ngFor="let user of userList" [value]="user.UserId">
                                    {{ user.UserName }}
                                </option>
                            </select>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button id="btnAuthOk" type="submit" class="btn btnAS me-1" [disabled]="!passcode || !enteredBy">OK</button>
                            <button class="btn btn-orange" type="button" (click)="closeModalById('authModal')">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>